interface AlertGlyphIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function AlertGlyphIcon({ size = 16, style, ...props }: AlertGlyphIconProps) {
  const sizeValue = typeof size === "number" ? `${size / 16}rem` : size;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: sizeValue, height: sizeValue, ...style }}
      {...props}
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <path d="M12 9v4M12 17h.01" />
    </svg>
  );
}
